
import React from 'react';
import { usePayment } from '@/context/PaymentContext';
import { formatDistanceToNow, format } from 'date-fns';
import { Bluetooth, Mail, User, DollarSign } from 'lucide-react';

const TransactionHistory = () => {
  const { transactions } = usePayment();
  
  if (transactions.length === 0) {
    return (
      <div className="text-center py-10">
        <p className="text-gray-500">No transactions yet</p>
      </div>
    );
  }
  
  return (
    <div className="space-y-4">
      {transactions.map((transaction) => (
        <div key={transaction.id} className="bg-white p-4 rounded-xl shadow-sm">
          <div className="flex justify-between items-start">
            <div>
              <div className="flex items-center gap-2">
                {transaction.method === 'bluetooth' ? (
                  <Bluetooth size={16} className="text-blue-500" />
                ) : transaction.method === 'email' ? (
                  <Mail size={16} className="text-blue-500" />
                ) : (
                  <User size={16} className="text-blue-500" />
                )}
                <h3 className="font-medium">{transaction.recipient}</h3>
              </div>
              <p className="text-sm text-gray-500">
                {formatDistanceToNow(new Date(transaction.timestamp), { addSuffix: true })}
              </p>
              <p className="text-xs text-gray-400 mt-1">
                From: {transaction.sender} ({transaction.senderEmail})
              </p>
              <p className="text-xs text-gray-400">
                To: {transaction.recipient} ({transaction.recipientEmail})
              </p>
            </div>
            <div className="text-right">
              <p className="font-semibold">${transaction.amount.toFixed(2)}</p>
              <p className="text-xs text-gray-500">
                Fee: ${transaction.fee.toFixed(2)}
              </p>
              <span className={`text-xs px-2 py-0.5 rounded-full ${
                transaction.status === 'completed' ? 'bg-green-100 text-green-800' :
                transaction.status === 'pending' ? 'bg-yellow-100 text-yellow-800' :
                'bg-red-100 text-red-800'
              }`}>
                {transaction.status}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TransactionHistory;
